export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["यदि आप व्यापार रद्द करते हैं, तो यह ऑपरेशन पूरा किए बिना बंद हो जाएगा।"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्या आप सुनिश्चित हैं कि आप व्यापार रद्द करना चाहते हैं?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["हां, रद्द करें"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नहीं, सक्रिय रखें"])}
}